import yoda from '@kibt/bridge';
import { versionCompare } from '@kibt/web-utils/version';
import { appVersion, isAndroid, isIOS } from '../device-info';
import queryString from 'query-string';
import { radar } from '@/common/log';
import { getMinBundleVersionById } from '../getMinBundleVersion';
import { getAbHeight } from '@/hooks/abTest/useAbScreenHeight';
import { getFailOverUrl } from '@kibt/web-utils/fail-over';
import { goAddAddressWhenNoAddress, parseAddressUrl } from './parseAddressUrl';
import { getSource } from '../utils/setSource';
import debounce from 'lodash/debounce';
import { getBundleInfo } from './getBundleInfo';
import { abPromise } from '@/store/useAbStore';
import { checkMediaSource } from '../utils/checkMediaSource';
import { BUNDLE_ID_LIST, getQuery } from '../const';
import { addSceneToUrl, addThemeStyleToUrl } from '../utils/modifyUrl';
import { addExtParamsToURL, addSourceToURL, modifyExtParamsToUrl } from '../utils/modifyUrlWithParams';
import { addInpQueryToUrl } from '../perf/inp';
import { kwaiShopUrlHandle } from './urlInterceptor/interceptors/kwaiShopUrlInterceptor';
import { execUrlInterceptor } from './urlInterceptor/execUrlInterceptor';
import { parseSearchUrl } from './parseSearchUrl';
import { reportCatchError } from '@/utils/reportCatchError';
import { useGlobalStore } from '@/store/useGlobalStore';
import { getQuerys } from '@/common/const';
import { getRouterUrl } from '@/hooks/useRouter';
/**
 * 判断是否需要使用CCT Webview打开
 */
export function isNeedCCTWebview(url: string) {
    // 电商自建后三方商品更少了，使用黑名单来判断是否使用cct webview
    const blackList = [
        // 'taptapshop.com',
        // 'shopping.wed2c.com',
        'shopee.com',
        'aliexpress.com',
        'alicdn.com',
        'mercadolivre.com',
        'amzn.to',
        'amazon.com',
        'casasbahia.com',
        'americanas.com',
        'magazineluiza.com',
        'shein.com',
        'patpat.com',
        'popopieshop.com',
        'niuniudaddy.com',
        'akibaba.com',
        'salonline.com',
        'descomplica.com',
        'dreamriverclub.com',
        'shoptap.com',
        'myshopify.com',
        'shopify.com',
        'tec.br',
        'welowshop.com',
        'conectlifes.com',
        'voxely.com,amazonaws.com',
    ];

    let urlHost = url;
    if (url.indexOf('?') > -1) {
        const index = url.indexOf('?');
        urlHost = url.slice(0, index);
    }

    for (let i = 0; i < blackList.length; i++) {
        const item = blackList[i];
        if (urlHost.includes(item)) {
            return true;
        }
    }
    return false;
}

/**
 * 使用CCT webview打开，如果打开失败，使用系统浏览器打开
 * cct webview旧版本有bad case，不能用caniuse判断是否可用，需要用版本判断是否可用
 * 6.4.10及其以上才可以用
 */
export function openByCCT({ url }: { url: string }) {
    const res = versionCompare(appVersion, '6.4.10');
    if (res >= 0) {
        return yoda.component
            .openCCT({ url })
            .then(() => {
                radar.event({
                    name: 'OpenUrl_CCT_Success',
                    eventType: 'SHOP_KRN_CUSTOM_EVENT',
                    params: { url },
                });
            })
            .catch(err => {
                radar.event({
                    name: 'OpenUrl_CCT_Success',
                    eventType: 'SHOP_KRN_CUSTOM_EVENT',
                    params: { url, err },
                });
                return yoda.tool.launchApp({
                    scheme: url,
                });
            });
    }
    console.log(`当前app版本为: ${appVersion}, 6.4.10及其以上才可以用cct webview`);
    return yoda.tool
        .launchApp({
            scheme: url,
        })
        .then(() => {
            radar.event({
                name: 'OpenUrl_LaunchApp_Success',
                eventType: 'SHOP_KRN_CUSTOM_EVENT',
                params: { url },
            });
        })
        .catch(err => {
            radar.event({
                name: 'OpenUrl_LaunchApp_Success',
                eventType: 'SHOP_KRN_CUSTOM_EVENT',
                params: { url, err },
            });
            return Promise.reject(err);
        });
}

interface FullWebviewOptions {
    title?: string;
}
interface HalfWebviewOptions {
    hideMask?: boolean;
    maskColor?: string;
    launchType?: number;
    corner?: number;
    height?: number;
    fullScreen?: string;
    showMask?: boolean;
}

function getFailBackUrl(url: string) {
    const targetUrl = getFailOverUrl(url);
    console.log('after getFailBackUrl', targetUrl);
    return targetUrl;
}

const addPageV2Query = async url => {
    const abInfo = (await abPromise) || {};
    console.log(abInfo, 'if_hit_orderpage_v2');
    if (abInfo.if_hit_orderpage_v2?.value) {
        const newUrl = queryString.stringifyUrl({
            url: url,
            query: {
                pageV2: '1',
            },
        });
        return newUrl;
    }
    return url;
};

/**
 * 前端控制
 */
export async function openUrlV1(args: {
    url: string;
    halfWebview?: boolean;
    options?: FullWebviewOptions | HalfWebviewOptions;
    isNeedSetTimeout?: boolean;
    refererPage?: string;
    fullScreen?: string;
    height?: number;
}) {
    const startTime = Date.now();
    const { url: _url, halfWebview = false, isNeedSetTimeout = false, options = {}, refererPage = '', fullScreen = '1', height: custumHeight } = args;
    // const _urlV2 = getFailBackUrl(_url);
    const parseUrl = queryString.parseUrl(_url);
    let redirectUrl = parseUrl.query.redirectUrl;

    // 设置电池栏背景色透明(目前只有购物车和提单页在大促期间会添加这个参数)
    // 新版店铺页也增加沉浸式
    try {
        const redirectUrl2 = queryString.parse(redirectUrl as string);
        const bundleId = redirectUrl2.bundleId as string;
        if (['MyShoppingCar', 'EcommOrderConfirm'].includes(bundleId)) {
            redirectUrl2.themeStyle = '1';
        }
        redirectUrl = queryString.stringify(redirectUrl2);
    } catch (e) {
        console.error(e);
        reportCatchError(e, {
            position: 'openUrlV1-themeStyle-1',
        });
    }

    try {
        // ios在url上加上minBundleVersion，安卓通过kSwitch
        if (redirectUrl && isIOS) {
            const redirectUrlParams = queryString.parse(redirectUrl as string);
            const bundleId = redirectUrlParams?.bundleId;
            const minBundleVersion = await getMinBundleVersionById(bundleId);

            if (minBundleVersion) {
                redirectUrl = queryString.stringify({
                    ...redirectUrlParams,
                    minBundleVersion,
                });
            }
        }
    } catch (e) {
        console.error(e);
    }

    const query: any = {};
    if (redirectUrl) {
        // 若是半屏打开需增加特定参数
        const halfWebviewParams = halfWebview
            ? {
                  cornerRadius: 16,
                  height: 1, // iosrn 新增跳转参数
                  foldRatio: custumHeight || 0.75, // iosrn 新增跳转参数
                  openSlideFullScreen: 1, // iosrn 新增跳转参数 表明是可拖拽的半屏
                  isHalf: 1, // iosrn 新增跳转参数
              }
            : {};
        redirectUrl = queryString.stringify({
            ...halfWebviewParams,
            ...queryString.parse(redirectUrl as string),
        });
        query.redirectUrl = redirectUrl;
    }
    // 上游透传了source，走业务侧自定义的
    query.source = parseUrl.query.source || getSource();
    query.sourceBundle = getQuery('bundleId');
    query.urlVersion = 1;

    let url = queryString.stringifyUrl({
        url: _url,
        query,
    });

    // 提单页V2.0，已推全
    // url = await addPageV2Query(url);
    url = await parseAddressUrl(url);
    url = await goAddAddressWhenNoAddress(url);
    url = await parseSearchUrl(url);

    url = addSceneToUrl(url);
    url = addInpQueryToUrl(url);
    url = addThemeStyleToUrl(url);

    // url拦截器
    url = await execUrlInterceptor(url, [
        // 在这个数组里面添加url拦截器
        kwaiShopUrlHandle,
    ]);

    console.log(`openUrlV1解析参数花费时间为: ${Date.now() - startTime}ms`);
    console.log('open url:::::', url, query);

    // 小游戏电商使用webview open打开会覆盖掉小程序进程，改用特殊的桥在小游戏进程打开url
    if (getQuery('urlOpenStyle') === 'inGameStack') {
        const res = versionCompare(appVersion, '10.10.30');
        if (res >= 0) {
            return (yoda.invoke ?? yoda.kwaiInvoke)?.('ug.openUrlInGameStack', {
                url,
                gameId: getQuery('gameId'),
            }).then(
                res => {
                    // deal resolve result
                    console.log('openUrlInGameStack success', res);
                },
                err => {
                    // deal reject result,业务异常 主动调用reject触发的
                    console.log('openUrlInGameStack err', err);
                    radar.event({
                        name: 'OpenUrl_InGameStack_Error',
                        eventType: 'SHOP_KRN_CUSTOM_EVENT',
                        params: { url, err },
                    });
                    return Promise.reject(err);
                }
            );
        }
    }

    //  判断是否需要使用cct webview打开
    if (isNeedCCTWebview(url)) {
        return openByCCT({ url });
    }

    if (halfWebview && appVersion.indexOf('9.10.10') === -1) {
        const newUrl = queryString.stringifyUrl({
            url,
            query: { webviewType: 'half' },
        });
        const height = custumHeight || (isIOS ? 0.8 : await getAbHeight());
        return yoda.component
            .loadNewUrlHalfPage({
                url: newUrl,
                launchType: 1,
                corner: 16,
                height,
                fullScreen,
                hideToolbar: !isIOS,
                ...options,
            })
            .catch(err => {
                radar.event({
                    name: 'OpenUrl_HalfWebview_Error',
                    eventType: 'SHOP_KRN_CUSTOM_EVENT',
                    params: { url, err, refererPage },
                });
                return yoda.webview
                    .open({
                        url,
                        launchOptions: {}, // 个别机型 不增加这个参数无法跳转
                        ...options,
                    })
                    .catch(err => {
                        radar.event({
                            name: 'OpenUrl_FullWebview_Error',
                            eventType: 'SHOP_KRN_CUSTOM_EVENT',
                            params: { url, err, refererPage },
                        });
                        return Promise.reject(err);
                    });
            });
    } else {
        // ios 9.3.30 新增桥 https://team.corp.kuaishou.com/task/T3657574
        if (isIOS && versionCompare(appVersion, '9.3.30') >= 0) {
            return yoda.component
                .openFullScreenWebView({
                    url,
                    ...options,
                })
                .catch(err => {
                    radar.event({
                        name: 'OpenUrl_FullScreenWebview_Error',
                        eventType: 'SHOP_KRN_CUSTOM_EVENT',
                        params: { url, err, refererPage },
                    });
                    return Promise.reject(err);
                });
        }

        // 这个if else 是为了解决在商详页跳到确认下单页时候的黑屏问题
        if (isNeedSetTimeout) {
            setTimeout(() => {
                return yoda.webview
                    .open({
                        url,
                        launchOptions: {}, // 个别机型 不增加这个参数无法跳转
                        ...options,
                    })
                    .catch(err => {
                        radar.event({
                            name: 'OpenUrl_FullWebview_1_Error',
                            eventType: 'SHOP_KRN_CUSTOM_EVENT',
                            params: { url, err, refererPage },
                        });
                        return Promise.reject(err);
                    });
            }, 0);
        } else {
            return yoda.webview
                .open({
                    url,
                    launchOptions: {}, // 个别机型 不增加这个参数无法跳转
                    ...options,
                })
                .catch(err => {
                    radar.event({
                        name: 'OpenUrl_FullWebview_2_Error',
                        eventType: 'SHOP_KRN_CUSTOM_EVENT',
                        params: { url, err, refererPage },
                    });
                    return Promise.reject(err);
                });
        }
    }
}

/**
 * @param options 前端处理的打开容器的参数
 * @returns viod
 * @warning option里不能随意增加字段，能让后端下发尽量让后端下发
 */
type frontEndAllowedOptions = {
    hideToolbar?: boolean;
    corner?: number;
    closeCurent?: boolean;
};
/**
 * 后端下发url
 * @param url 跳转的url，由后端下发
 * @returns viod
 */
export async function openUrlV2({ url, options }: { url: string; options?: frontEndAllowedOptions }) {
    const startTime = Date.now();
    // 补充遗漏的地址跳转相关实验逻辑
    let newUrl = url;
    newUrl = await parseAddressUrl(newUrl);
    newUrl = await goAddAddressWhenNoAddress(newUrl);

    newUrl = addSceneToUrl(newUrl);
    newUrl = addInpQueryToUrl(newUrl);
    newUrl = addThemeStyleToUrl(newUrl);

    // url拦截器
    newUrl = await execUrlInterceptor(newUrl, [
        // 在这个数组里面添加url拦截器
        kwaiShopUrlHandle,
    ]);
    const urlWithSource = addSourceToURL(newUrl);
    const urlWithExtParams = addExtParamsToURL(urlWithSource);

    const parseUrl = queryString.parseUrl(urlWithExtParams);
    const redirectUrl = parseUrl.query.redirectUrl;

    const redirectUrlQuerys = queryString.parse((redirectUrl as string) || '');
    const h5ContinerInit = parseUrl.query.__h5_container_init__ ? JSON.parse(parseUrl.query.__h5_container_init__ as string) : {};
    console.log(`openUrlV2解析参数花费时间为: ${Date.now() - startTime}ms`);

    // 打开RN半屏容器
    if (redirectUrlQuerys.bundleId && Number(redirectUrlQuerys.isHalf) === 1) {
        // console.log('redirectUrlQuerys', redirectUrlQuerys, typeof redirectUrlQuerys.isHalf, parseUrl); // {"bundleId": "Detail", "componentName": "Detail", "height": "1", "isHalf": "0"}
        let loadNewHalfPageConfig;
        if (isIOS) {
            loadNewHalfPageConfig = {
                url: urlWithExtParams,
                hideToolbar: false,
                ...options,
            };
        } else {
            // 对字段做映射
            const iosMapToAndroidConfig = (querys: { isHalf: number; foldRatio: number; openSlideFullScreen: number }) => {
                return {
                    launchType: String(querys.isHalf),
                    height: String(querys.foldRatio),
                    fullScreen: String(querys.openSlideFullScreen),
                };
            };
            // 通过桥的参数打开loadNewHalfPage
            loadNewHalfPageConfig = {
                url: urlWithExtParams,
                hideToolbar: true,
                ...iosMapToAndroidConfig(redirectUrlQuerys as any),
                ...options,
            };
        }
        return yoda.component
            .loadNewUrlHalfPage(loadNewHalfPageConfig)
            .catch(() => {
                radar.event({
                    name: 'BackendUrlOpnenError',
                    params: { url: urlWithExtParams, loadNewHalfPageConfig, bridge: 'loadNewUrlHalfPage', platform: isAndroid ? 'Android' : 'IOS' },
                });
                return yoda.webview
                    .open({
                        url: urlWithExtParams,
                        launchOptions: {}, // 个别机型 不增加这个参数无法跳转
                        ...options,
                    })
                    .catch(err => {
                        radar.event({
                            name: 'BackendUrlOpnenError',
                            params: { url: urlWithExtParams, bridge: 'loadNewUrlHalfPage', platform: isAndroid ? 'Android' : 'IOS' },
                        });
                        return Promise.reject(err);
                    });
            })
            .finally(() => {
                if (options?.closeCurent) {
                    yoda.component.backOrCloseWeb();
                }
            });
    }
    // 打开h5半屏
    else if (Number(h5ContinerInit.launchType)) {
        // 读h5ContinerInit，通过loadNewHalfPage打开新页面
        yoda.component
            .loadNewUrlHalfPage({
                url: urlWithExtParams,
                ...h5ContinerInit,
            })
            .finally(() => {
                if (options?.closeCurent) {
                    yoda.component.backOrCloseWeb();
                }
            });
    }
    // 打开全屏
    else {
        // 打开全屏
        if (isIOS) {
            // ios 使用 openFullScreenWebView 打开全屏容器
            if (isIOS && versionCompare(appVersion, '9.3.30') >= 0) {
                return yoda.component
                    .openFullScreenWebView({
                        url: urlWithExtParams,
                        ...options,
                    })
                    .catch(err => {
                        radar.event({
                            name: 'BackendUrlOpnenError',
                            params: { url: urlWithExtParams, bridge: 'openFullScreenWebView', platform: isAndroid ? 'Android' : 'IOS' },
                        });
                        return Promise.reject(err);
                    })
                    .finally(() => {
                        if (options?.closeCurent) {
                            yoda.component.backOrCloseWeb();
                        }
                    });
            }
        }
        return yoda.webview
            .open({
                url: urlWithExtParams,
                launchOptions: {}, // 个别机型 不增加这个参数无法跳转
                ...options,
            })
            .catch(err => {
                radar.event({
                    name: 'BackendUrlOpnenError',
                    params: { url: urlWithExtParams, bridge: 'open', platform: isAndroid ? 'Android' : 'IOS' },
                });
                return Promise.reject(err);
            })
            .finally(() => {
                if (options?.closeCurent) {
                    yoda.component.backOrCloseWeb();
                }
            });
    }
}

// 将 url 改成外投的链接
const modifyUrlToOutsideUrl = (url: string) => {
    if (!url) return null;
    const parseUrl = queryString.parseUrl(url);
    const redirectUrl2 = queryString.parse(parseUrl?.query?.redirectUrl as string);
    const targetBundleId = redirectUrl2?.bundleId as string; // 目标 Bundle

    const getNewUrl = (outsidePath: string) => window.location.origin + outsidePath + '?' + queryString.stringify(parseUrl.query);

    const newUrl = (() => {
        if (targetBundleId === BUNDLE_ID_LIST.EcommOrderConfirm) {
            return getNewUrl('/shop/order-confirm');
        }
        if (targetBundleId === BUNDLE_ID_LIST.DETAIL) {
            const { encryptItemId } = parseUrl.query;
            if (!encryptItemId) return null;
            return getNewUrl(`/shop/detail/${encryptItemId}`);
        }
        if (targetBundleId === BUNDLE_ID_LIST.EcommAddress) {
            const pathName = parseUrl.url.split('?')[0];
            if (pathName.endsWith('/address/add')) {
                return getNewUrl('/shop/address/add');
            }
            return getNewUrl('/shop/address');
        }
        if (targetBundleId === BUNDLE_ID_LIST.OrderDetail) {
            return getNewUrl('/shop/order-detail');
        }
        // 订单列表是 Vue H5
        if (url.split('?')[0].endsWith('/shop/c/pay-center/order-list')) {
            return getNewUrl('/shop/order-list');
        }
        // 保障页也是 H5
        if (url.split('?')[0].endsWith('/shop/c/detail/guarantee')) {
            return getNewUrl('/shop/guarantee');
        }
        return url;
    })();
    return newUrl;
};

const checkIfSameOrigin = (url: string) => {
    if (url.startsWith('/shop')) return true;
    const urlObj = new URL(url);
    return urlObj.host === window.location.host;
};

const getSPAPathAndQuery = (url: string) => {
    let pathName = '';
    if (url.startsWith('/shop')) pathName = url.split('?')[0];
    else pathName = new URL(url).pathname;

    if (pathName.startsWith('/shop/c/')) {
        pathName = pathName.replace('/shop/c/', '/');
    } else if (pathName.startsWith('/shop')) {
        pathName = pathName.replace('/shop/', '/');
    }

    return `${pathName}?${url.split('?')[1]}`;
};

async function openUrlPure(
    paramsV1: {
        url: string;
        halfWebview?: boolean;
        options?: FullWebviewOptions | HalfWebviewOptions;
        isNeedSetTimeout?: boolean;
        refererPage?: string;
        fullScreen?: string;
        height?: number;
        routerReplace?: boolean; // 是否使用router.replace
    },
    paramsV2?: {
        url: string;
        options?: frontEndAllowedOptions;
    }
) {
    const routerHistory = useGlobalStore.getState().routerHistory;
    let url = await goAddAddressWhenNoAddress(paramsV1.url || paramsV2.url);
    if (!url) return null;

    url = await modifyExtParamsToUrl(url);
    url = modifyUrlToOutsideUrl(url);
    if (!url) return null;

    if (routerHistory && checkIfSameOrigin(url)) {
        const spaUrl = getSPAPathAndQuery(url);
        if (paramsV1.routerReplace) {
            routerHistory.replace(spaUrl);
        } else {
            routerHistory.push(spaUrl);
        }
        return;
    }
    if (url.startsWith('https://') || url.startsWith('http://')) {
        window.open(url);
        return;
    }
    checkMediaSource(paramsV2?.url || paramsV1.url);
    // 如果后端下发了url，走后端的下发链接
    if (paramsV2?.url) {
        return openUrlV2(paramsV2);
    } else {
        return openUrlV1(paramsV1);
    }
}
// 加入800ms防抖，解决线上点击跳转按钮时多次打开RN容器问题
export const openUrl = debounce(openUrlPure, 800, {
    trailing: false,
    leading: true,
    maxWait: 1500,
});
